import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsent } from './CookieConsentContext';
import { disableGA, initGA, trackPageView } from '../../configuration/analytics';

export const GoogleAnalytics: React.FC = () => {
  const location = useLocation();
  const { cookiePreferences } = useCookieConsent();

  // Load Google Analytics only once analytics consent is given, and switch it
  // off again the moment it is withdrawn - the script cannot be unloaded from
  // the page, so it has to be told to stop.
  useEffect(() => {
    if (cookiePreferences.analytics) {
      initGA();
    } else {
      disableGA();
    }
  }, [cookiePreferences.analytics]);

  // Track page views on route changes
  useEffect(() => {
    if (cookiePreferences.analytics) {
      trackPageView(location.pathname + location.search);
    }
  }, [location, cookiePreferences.analytics]);

  return null; // This component doesn't render anything
};
